(function () {
  'use strict';

  function formatCurrency(value) {
    return '$' + value.toLocaleString('en-US');
  }

  function initQuoteBuilder(root) {
    var builders = (root || document).querySelectorAll('.sc-quote-builder');

    builders.forEach(function (builder) {
      var vehicleInputs = builder.querySelectorAll('.sc-quote-builder__input--vehicle');
      var addonInputs = builder.querySelectorAll('.sc-quote-builder__input--addon');
      var totalEl = builder.querySelector('.sc-quote-builder__total-value');
      var breakdownEl = builder.querySelector('.sc-quote-builder__breakdown');
      var copyBtn = builder.querySelector('.sc-quote-builder__copy');
      var copyTextEl = copyBtn ? copyBtn.querySelector('.sc-quote-builder__copy-text') : null;

      if (!totalEl) return;

      function recalc() {
        var total = 0;
        var lines = [];

        vehicleInputs.forEach(function (input) {
          if (input.checked) {
            var price = parseFloat(input.value) || 0;
            total += price;
            lines.push({ label: input.getAttribute('data-label'), price: price });
          }
        });

        addonInputs.forEach(function (input) {
          if (input.checked) {
            var price = parseFloat(input.value) || 0;
            total += price;
            lines.push({ label: input.getAttribute('data-label'), price: price, addon: true });
          }
        });

        totalEl.textContent = formatCurrency(total);

        if (breakdownEl) {
          breakdownEl.innerHTML = '';
          lines.forEach(function (line) {
            var li = document.createElement('li');

            var labelSpan = document.createElement('span');
            labelSpan.textContent = line.label;

            var priceSpan = document.createElement('span');
            priceSpan.textContent = (line.addon ? '+' : '') + formatCurrency(line.price);

            li.appendChild(labelSpan);
            li.appendChild(priceSpan);
            breakdownEl.appendChild(li);
          });
        }

        if (copyBtn) {
          var summary = 'StagedCustoms — Starlight Headliner Build\n';
          lines.forEach(function (line) {
            summary += '- ' + line.label + ' (' + (line.addon ? '+' : '') + formatCurrency(line.price) + ')\n';
          });
          summary += 'Estimated Total: ' + formatCurrency(total);
          copyBtn.setAttribute('data-summary', summary);
        }
      }

      vehicleInputs.forEach(function (input) {
        input.addEventListener('change', recalc);
      });
      addonInputs.forEach(function (input) {
        input.addEventListener('change', recalc);
      });

      if (copyBtn) {
        copyBtn.addEventListener('click', function () {
          var summary = copyBtn.getAttribute('data-summary') || '';
          var resetLabel = copyBtn.getAttribute('data-copy-text') || 'COPY MY BUILD';
          var copiedLabel = copyBtn.getAttribute('data-copied-text') || 'COPIED';

          function showCopied() {
            if (copyTextEl) {
              copyTextEl.textContent = copiedLabel;
              setTimeout(function () {
                copyTextEl.textContent = resetLabel;
              }, 2000);
            }
          }

          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(summary).then(showCopied).catch(function () {});
          } else {
            var textarea = document.createElement('textarea');
            textarea.value = summary;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();
            try { document.execCommand('copy'); showCopied(); } catch (e) {}
            document.body.removeChild(textarea);
          }
        });
      }

      recalc();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initQuoteBuilder(); });
  } else {
    initQuoteBuilder();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initQuoteBuilder(event.target);
  });
})();
